// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"e1ef0153","787":"21574be4","850":"6747406f"}[chunkId] + ".chunk.js";
};